import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailSignupModal from "./EmailSignupModal";
import markLogo from "../images/markLogo.jpg";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "transparent!important",
    color: "#000",
    boxShadow: "none",
    position: "absolute!important",
    width: "100%",
  },
  menuButton: {
    color: "white!important",
    background: "transparent!important",
    padding: "0.25rem .5rem!important",
    margin: "0 .25rem!important",
    borderRadius: "0!important",
    textTransform: "uppercase!important",
  },
  link: {
    textDecoration: "none",
    color: "white!important",
    fontFamily: "'Montserrat'",
    fontSize: "1rem",
    lineHeight: "1.25",
    padding: "0 .25rem",
  },
  toolbar: {
    justifyContent: "space-between",
  },
  drawerList: {
    width: 250,
  },
  menuIcon: {
    color: "white",
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [emailOpen, setEmailOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const location = useLocation();

  const drawerList = () => (
    <div
      className={classes.drawerList}
      onClick={(e) => {
        if (e.target.tagName !== "A") toggleDrawer(false);
      }}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItemButton component={Link} to="/" onClick={toggleDrawer(false)}>
          <ListItemText primary="HOME" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/meetmark"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="MEET MARK" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/priorities"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="ISSUES" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/endorsements"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="ENDORSEMENTS" />
        </ListItemButton>
        <ListItemButton
          component="a"
          href="https://forms.gle/5pwrC3iqZqjzfoKu6"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="CONTACT" />
        </ListItemButton>
        <ListItemButton
          component="a"
          href="https://docs.google.com/forms/d/e/1FAIpQLScPgCTNLNrh_6SHIDXPnY8TlZszp8V3Bg1iY2ITJm8C5_Y_bg/viewform"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="VOLUNTEER" />
        </ListItemButton>
        {/* <ListItemButton
          component="a"
          onClick={() => setEmailOpen(true)}
        >
          <ListItemText primary="JOIN US" />
        </ListItemButton> */}

        <ListItemButton
          component="a"
          href="https://secure.ngpvan.com/beSGPrpSQ06bfZh72prCqw2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="DONATE" />
        </ListItemButton>
      </List>
    </div>
  );

  return (
    <AppBar className={classes.appBar} sx={{ background: "transparent", p: 2 }}>
      <Toolbar className={classes.toolbar} sx={{ px: "0!important" }}>
        <Box display={{ xs: "none", md: "flex", width: "100%" }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
              py: 1,
              px: 1,
              width: "100%",
              borderRadius: ".5rem",
            }}
          >
            {/* Logo */}
            <Grid item>
              <Link to="/">
                <Box
                  component="img"
                  src={markLogo}
                  alt="Mark Logo"
                  sx={{
                    borderRadius: ".5rem",
                    height: "100px",
                    boxShadow:
                      "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
                  }}
                />
              </Link>
            </Grid>
            <Grid item>
              <Button
                className={`${classes.link}`}
                sx={{
                  color: "white!important",
                  margin: "0 .25rem!important",
                  padding: "0.25rem .5rem!important",
                  background: "transparent!important",
                  borderRadius: "0!important",
                  textTransform: "uppercase!important",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                <Link to="/meetmark" className={`${classes.link}`}>
                  MEET MARK
                </Link>
              </Button>

              <Button className={classes.menuButton}>
                <Link to="/priorities" className={`${classes.link}`}>
                  Issues
                </Link>
              </Button>
              <Button className={classes.menuButton}>
                <Link to="/endorsements" className={`${classes.link}`}>
                  ENDORSEMENTS
                </Link>
              </Button>
              <Button
                component="a"
                href="https://forms.gle/5pwrC3iqZqjzfoKu6"
                target="_blank"
                rel="noopener noreferrer"
                variant="text"
                color="inherit"
                className={classes.menuButton}
                sx={{
                  color: "white!important",
                  padding: "0 .25rem",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                Contact
              </Button>
              {/* <Button
                className={classes.menuButton}
                onClick={() => setEmailOpen(true)}
              >
                <span className={classes.link}>join our team</span>
              </Button> */}
              {/* <Button className={classes.menuButton}>
                <Link to="/media" className={`${classes.link}`}>
                  Media
                </Link>
              </Button> */}
              {/* <Button
                className={classes.menuButton}
          
              >
                <span className={classes.link}>store</span>
              </Button> */}

              <IconButton
                component="a"
                href="https://www.instagram.com/mark.brewster_/profilecard/?igsh=MWVrMDN0eWlzY3E0cQ==/mark_brewster"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <InstagramIcon
                  sx={{ color: location.pathname === "/" ? "white" : "white" }}
                />
              </IconButton>
              {/* <IconButton
                component="a"
                href="https://x.com/Mark_Brewster"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <XIcon
                  sx={{ color: location.pathname === "/" ? "white" : "white" }}
                />
              </IconButton> */}
              <IconButton
                component="a"
                href="https://facebook.com/profile.php?id=61577947200300"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon
                  sx={{ color: location.pathname === "/" ? "white" : "white" }}
                />
              </IconButton>
              <Button
                className={classes.menuButton}
                sx={{
                  background: "#106cb7!important",
                  p: "0.75rem 2rem!important",
                  borderRadius: ".25rem!important",
                  ml: "1rem!important",
                }}
              >
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLScPgCTNLNrh_6SHIDXPnY8TlZszp8V3Bg1iY2ITJm8C5_Y_bg/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  Volunteer
                </a>
              </Button>
              <Button
                className={classes.menuButton}
                sx={{
                  background: "#FF0000!important",
                  p: "0.75rem 2rem!important",
                  borderRadius: ".25rem!important",
                  ml: ".5rem!important",
                }}
              >
                <a
                  href="https://secure.ngpvan.com/beSGPrpSQ06bfZh72prCqw2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  donate
                </a>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box display={{ xs: "flex", md: "none",marginTop: '-28px' }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerList()}
      </Drawer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </AppBar>
  );
};

export default Navbar;
